import {Component, Inject, OnInit} from '@angular/core';
import {ApinfoService} from './providers/apinfo.service';
import {GlobalVariable} from './config/variable';
import { BootstrapComponentBase, INJECTION_TOKEN_ENVIRONMENT_WITH_BUILD, EnvironmentWithBuildInfo } from '@xsk/ng-basis';
import { GeneralService } from '@velites/ng-common';

@Component({
  selector: 'nzo-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent extends BootstrapComponentBase implements OnInit {
  globalVariable = GlobalVariable;

  constructor(
    @Inject(INJECTION_TOKEN_ENVIRONMENT_WITH_BUILD) envWithBuild: EnvironmentWithBuildInfo = null,
    generalService: GeneralService,
    private apinfoService: ApinfoService
  ) {
    super(envWithBuild, generalService);
  }

  ngOnInit() {
    this.apinfoService.getApiInfo();
  }
}

